import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=406100f4&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=406100f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406100f4",
  null
  
)

export default component.exports